import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./CrisisSection.scss";

const CrisisSection = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth > 991);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  const statistics = [
    {
      value: "₹2,500 cr",
      label: "Annual Loss Due to Paper Leaks",
      icon: "/LandingPageImages/AnnualLoss .svg",
      cardClass: "card-1",
    },
    {
      value: "45%",
      label: "Exams Compromised Yearly",
      icon: "/LandingPageImages/ExamsCompromisedYearly.svg",
      cardClass: "card-2",
    },
    {
      value: "12M+",
      label: "Students Affected",
      icon: "/LandingPageImages/StudentsAffected.svg",
      cardClass: "card-3",
    },
    {
      value: "78%",
      label: "Trust Deficit in Current System",
      icon: "/LandingPageImages/TrustDeficit.svg",
      cardClass: "card-4",
    },
  ];

  return (
    <section className="crisis-section">
      <div className="">
        <div className="crisis-content p-40">
          <h2 className="crisis-title">The Crisis We're Solving</h2>
          <p className="crisis-description">
            Paper leaks and examination fraud have shattered trust in our education system. Students lose opportunities, institutions lose credibility, and the nation loses talent.
          </p>
        </div>

        <div className="statistics-grid p-40">
          {statistics.map((stat, index) => (
            <motion.div
              key={index}
              className={`stat-card ${stat.cardClass}`}
              animate={isDesktop ? {
                y: [0, 20, 0],
              } : {}}
              transition={isDesktop ? {
                duration: 3 + index * 0.5,
                repeat: Infinity,
                ease: "easeInOut",
                delay: index * 0.3,
              } : {}}
            >
              <h3 className="stat-value">{stat.value}</h3>
              <div className="stat-label"><p>{stat.label}</p>
                <img src={stat.icon} alt={stat.label} width={100} height={100} />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CrisisSection;

